import TechnicalDataWidget from "./technical-data/TechnicalDataWidget";
import CarbonFootprintWidget from "./carbon-footprint/CarbonFootprintWidget";
import HandoverDocumentsWidget from "./handover-documentation/HandoverDocumentsWidget";
import BillOfMaterialsWidget from "./bill-of-materials/BillOfMaterialsWidget";

// Registry mapped by idShort
const widgetRegistryByIdShort = {};

// Or: Registry mapped by semanticId
const widgetRegistryBySemanticId = {
  "https://admin-shell.io/ZVEI/TechnicalData/Submodel/1/2": [TechnicalDataWidget],
  "0173-1#01-AHE712#001": [CarbonFootprintWidget],
  "0173-1#01-AHF578#001": [HandoverDocumentsWidget],
  "https://admin-shell.io/idta/HierarchicalStructures/1/0/Submodel": [BillOfMaterialsWidget]
};

export function getWidgetsForSubmodel(submodel) {
  const idShort = submodel?.idShort;
  const semanticId = submodel?.semanticId?.keys?.[0]?.value;

  const widgets = [
    ...(widgetRegistryByIdShort[idShort] || []),
    ...(widgetRegistryBySemanticId[semanticId] || [])
  ];

  return widgets;
}
